/** 舊生預建／認領、識別黑名單 API */
import apiService from '@/api/apiService';

export const listLegacyStudentPrecreates = (params = {}) =>
    apiService.GET('/api/admin/legacy-student-precreates', params);

export const listLegacyStudentCollisions = (params = {}) =>
    apiService.GET('/api/admin/legacy-student-precreates/collisions', params);

export const attachLegacyStudentCollision = (id) =>
    apiService.POST(`/api/admin/legacy-student-precreates/collisions/${id}/attach`, {});

export const importLegacyStudentPrecreates = (payload) =>
    apiService.POST('/api/admin/legacy-student-precreates/import', payload, {
        timeout: 55000,
        skipNotification: true
    });

export const cancelLegacyStudentPrecreate = (id, payload = {}) =>
    apiService.POST(`/api/admin/legacy-student-precreates/${id}/cancel`, payload);

export const updateLegacyStudentPrecreateNotes = (id, notes) =>
    apiService.PUT(`/api/admin/legacy-student-precreates/${id}/notes`, { notes });

export const backfillLegacyStudentCompletions = (id, completions) =>
    apiService.POST(
        `/api/admin/legacy-student-precreates/${id}/backfill-completions`,
        { completions }
    );
export const listAccessBlocklist = (params = {}) =>
    apiService.GET('/api/admin/access-blocklist', params);

export const createAccessBlocklist = (payload) =>
    apiService.POST('/api/admin/access-blocklist', payload);

export const liftAccessBlocklist = (id, lift_reason) =>
    apiService.POST(`/api/admin/access-blocklist/${id}/lift`, { lift_reason });

export const blacklistUser = (userId, reason) =>
    apiService.POST(`/api/admin/users/${userId}/blacklist`, { reason });

export const unblacklistUser = (userId, reason) =>
    apiService.POST(`/api/admin/users/${userId}/unblacklist`, { reason });

export const deregisterPartner = (userId, deregister_reason) =>
    apiService.PUT(`/api/admin/user-partners/${userId}/sync`, {
        deregister: true,
        deregister_reason
    });
